import gql from 'graphql-tag'

export const QUERY_GET_DATA_PER_OPERATOR = gql`
  query OperationalPerformance(
    $initialDate: String
    $finalDate: String
    $search: String
    $units: [ID]
    $page: Int!
    $pageSize: Int!
    $sort: [String]
    $sortDirection: [SortDirection]
  ) {
    operationalPerformance(
      initialDate: $initialDate
      finalDate: $finalDate
      search: $search
      units: $units
      page: $page
      pageSize: $pageSize
      sort: $sort
      sortDirection: $sortDirection
    ) {
      operators {
        id
        nome
        unit {
          name
        }
        coupons_identified_percentage
        coupons_identified
        coupons_total
        revenue_identified_percentage
        revenue_identified
        revenue_identified_total
      }
      page
      records
    }
  }
`
